import { cva } from 'class-variance-authority';

const snackbarBaseStyles = [
  'shadow',
  'flex',
  'p-3',
  'absolute',
  'm-4',
  'min-w-[300px]',
  'rounded-md',
  'z-50',
  'transition-all',
  'duration-500',
];

const snackbarStylesSAG = cva([
  ...snackbarBaseStyles,
  'text-[#000028]',
  'bg-[#F3F3F0]',
  'dark:bg-[#23233C]',
  'dark:text-white',
]);

const snackbarStylesSHS = cva([
  ...snackbarBaseStyles,
  'text-[#666666]',
  'bg-white',
  'dark:bg-[#1a1a1a]',
  'dark:text-white',
]);

export { snackbarStylesSAG, snackbarStylesSHS };
